import React from "react";
import { Flex } from "grid-styled";
import { Spring } from "react-spring";
import { TimingAnimation, Easing } from "react-spring/dist/addons";
import { Heading, Measure, TextLink } from "../globals";

const Introduction = ({ nBooks }) => (
    <Flex flexDirection="column" alignItems="center">
        <Spring
            from={{
                opacity: 0,
            }}
            to={{
                opacity: 1,
            }}
            delay={500}
            impl={TimingAnimation}
            config={{
                duration: 500,
                easing: Easing.ease,
            }}
        >
            {(styles) => (
                <div style={styles}>
                    <Heading
                        is="h1"
                        fontSize={7}
                        textAlign="center"
                        style={{ textWrap: "balance" }}
                    >
                        {`${nBooks} Books`} Every Designer Should Read
                    </Heading>
                </div>
            )}
        </Spring>
        <Spring
            from={{
                opacity: 0,
            }}
            to={{
                opacity: 1,
            }}
            delay={1500}
            impl={TimingAnimation}
            config={{
                duration: 500,
                easing: Easing.ease,
            }}
        >
            {(styles) => (
                <div style={styles}>
                    <Measure
                        is="p"
                        mt={6}
                        fontSize={4}
                        textAlign="center"
                        color="#3D3D3D"
                        style={{ textWrap: "pretty" }}
                    >
                        Some of industry's best designers answer the question
                        "What book should designers read and why?"
                    </Measure>
                </div>
            )}
        </Spring>
        <Spring
            from={{
                opacity: 0,
            }}
            to={{
                opacity: 1,
            }}
            delay={2500}
            impl={TimingAnimation}
            config={{
                duration: 500,
                easing: Easing.ease,
            }}
        >
            {(styles) => (
                <div style={styles}>
                    <Flex justifyContent="center" mt={6}>
                        <TextLink
                            href="https://twitter.com/vincentmvdm"
                            target="_blank"
                            rel="noopener noreferrer"
                            fontSize={4}
                            shade="light"
                        >
                            By @vincentmvdm
                        </TextLink>
                    </Flex>
                </div>
            )}
        </Spring>
    </Flex>
);

export default Introduction;



// WEBPACK FOOTER //
// ./src/components/Introduction/index.js